/**
 * Thin router shell. Each route renders its page inside the shared Layout.
 */
import { Route, Routes } from "react-router-dom";
import { AuthGate } from "./components/AuthGate";
import { Layout } from "./components/Layout";
import { Login } from "./pages/Login";
import { Library } from "./pages/Library";
import { Queue } from "./pages/Queue";
import { NowPlaying } from "./pages/NowPlaying";
import { Stats } from "./pages/Stats";
import { Settings } from "./pages/Settings";
import { DevLayout } from "./pages/dev/DevLayout";
import { DevTools } from "./pages/dev/DevTools";
import { DevLogSessions } from "./pages/dev/DevLogSessions";
import { DevLogLive } from "./pages/dev/DevLogLive";
import { DevLogViewer } from "./pages/dev/DevLogViewer";

const App: React.FC = () => (
  <Routes>
    <Route path="/login" element={<Login />} />
    <Route
      element={
        <AuthGate>
          <Layout />
        </AuthGate>
      }
    >
      <Route index element={<Library />} />
      <Route path="queue" element={<Queue />} />
      <Route path="now-playing" element={<NowPlaying />} />
      <Route path="stats" element={<Stats />} />
      <Route path="settings" element={<Settings />} />
      <Route path="dev" element={<DevLayout />}>
        <Route index element={<DevTools />} />
        <Route path="logs/live" element={<DevLogLive />} />
        <Route path="logs/:sessionId" element={<DevLogViewer />} />
        <Route path="logs" element={<DevLogSessions />} />
      </Route>
      <Route path="*" element={<Library />} />
    </Route>
  </Routes>
);

export default App;
